if (!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.errorHtml = this.querySelector('template')?.content?.firstElementChild?.cloneNode(true) || null;
      this.onClickRefreshList = this.onClickRefreshList.bind(this);

      if (this.hasAttribute('available')) {
        this.fetchAvailability(this.dataset.variantId);
      }
    }

    fetchAvailability(variantId) {
      if (!variantId) return;

      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch((e) => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      if (variant?.available) {
        this.dataset.variantId = String(variant.id);
        this.setAttribute('available', '');
        this.fetchAvailability(variant.id);
      } else {
        this.clear();
      }
    }

    clear() {
      this.removeAttribute('available');
      this.innerHTML = '';
      document.querySelector('#Modal-PickupAvailability')?.remove();
    }

    renderError() {
      this.innerHTML = '';
      if (!this.errorHtml) return;
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      document.querySelector('#Modal-PickupAvailability')?.remove();

      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.clear();
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      const modal = sectionInnerHTML.querySelector('#Modal-PickupAvailability');
      if (modal) {
        document.body.appendChild(modal);
        const wrapper = modal.querySelector('.modal-component__wrapper');
        const colorClassesToApply = (this.dataset.productPageColorScheme || '').split(' ').filter(Boolean);
        colorClassesToApply.forEach((cls) => wrapper?.classList.add(cls));

        if (window.theme?.bindModalToggles) {
          window.theme.bindModalToggles();
        } else {
          document.querySelectorAll('[data-modal-toggle]').forEach((button) => {
            const selector = button.getAttribute('data-modal-toggle');
            if (!selector || selector[0] !== '#') return;
            if (button.__modalToggleSelector === selector && button.__modalToggleHandler) return;
            if (button.__modalToggleHandler) button.removeEventListener('click', button.__modalToggleHandler);
            const handler = (event) => {
              event.preventDefault();
              const m = document.querySelector(selector);
              if (!m || typeof m.show !== 'function' || typeof m.close !== 'function') return;
              m.isOpen ? m.close() : m.show(button);
            };
            button.__modalToggleSelector = selector;
            button.__modalToggleHandler = handler;
            button.addEventListener('click', handler);
          });
        }
        return;
      }
    }
  }

  customElements.define('pickup-availability', PickupAvailability);
}
